import pxToRem from './pxToRem'; // These are based on the spacers in web.

var base = 16; // 1rem

var variations = [0, 0.25, 0.5, 1, 1.5, 2]; // 4px, 8px, 16px, 24px, 32px

var spacers = variations.map(function (s) {
  return pxToRem(base * s);
});
export default function spacing(spacer1, spacer2, spacer3, spacer4) {
  var spacings = [spacer1, spacer2, spacer3, spacer4].filter(function (s) {
    return s !== undefined;
  });
  return spacings.map(function (s) {
    return spacers[s];
  }).join(' ');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shazambanking/sdk/styles/util/spacing.js
// module id = 517
// module chunks = 0